import styled from 'styled-components';

type IconProps = {
  w: string;
  h: string;
  url: string;
};

const Icon = styled.div`
  height: ${(props: IconProps) => (props.h ? props.h : 'auto')};
  width: ${(props: IconProps) => (props.w ? props.w : 'auto')};

  background-image: url(${(props: IconProps) => props.url});
`;

export default Icon;
